// 信息脱敏格式化 统一规范

// 手机号脱敏
export const phoneNoMaskFormat = (phone: string): string => phone.replace(/^(\d{3})(\d{4})(\d{4})$/g, '$1 **** $3');

// 姓名脱敏 保留第一个字
export const nameMaskFormat = (name: string): string => {
  if (name.length > 1) {
    let mask = '';
    for (let i = 0; i < name.length - 1; i++) {
      mask += '*';
    }
    return name.slice(0, 1) + mask;
  }
  return name;
};

// 身份证号脱敏
export const idNoMaskFormart = (idCard: string): string => idCard.replace(/^(.{3})(?:\d+)(.{4})$/, '$1 *** **** **** $2');

// 银行卡号 脱敏
export const cardNoMaskFormat = (value: string): string => value.replace(/^(.{4})(?:\d+)(.{4})$/, '$1 **** **** $2');

// 银行卡号 脱敏 （去除空格版）
export const cardMaskFormat = (value: string): string => value.replace(/^(.{4})(?:\d+)(.{4})$/, '$1********$2');
